// extracted by mini-css-extract-plugin
export var container = "recordContainer-module--container--nvluq";
export var gridContainer = "recordContainer-module--gridContainer--dGf78";
export var title = "recordContainer-module--title--khrEz";